// 资源库页翻译 - 知识库、MCP服务器等

export const zh = {
  // Knowledge Base
  searchKnowledge: '搜索知识库...',
  searchTemplates: '搜索模板...',
  searchTools: '搜索工具治理策略...',
  searchMCPServers: '搜索 MCP 服务器...',
  documents: '文档',
  comingSoon: '即将上线',
  knowledgeBaseDescription: '知识库功能正在开发中',
  skillTemplates: '对话模板',
  // 产物中心
  artifactShareAction: '分享链接',
  artifactShareCopied: '链接已复制',
  openSourceThread: '来源对话',
  expertsLockedDesc: '能力包管理内容仅对管理团队开放，如需操作请联系管理员',
  expertsEditLockedDesc: '仅超级管理员与编辑管理员可编辑专家配置',
  newTemplate: '新建模板',
  templateRequiredFields: '模板 Key、名称和启动提示词为必填项',
  templateSaved: '模板已保存',
  templateDeleted: '模板已删除',
  templateNoDescription: '暂无描述',
  noTemplatesFound: '未找到模板',
  templateDetail: '模板详情',
  createTemplate: '创建模板',
  templateEditorHint: '把常见工作流沉淀为可复用入口。',
  useTemplate: '使用模板',
  templateKey: '模板 Key',
  category: '分类',
  templateModeSimple: '简单模式',
  templateModeComplex: '复杂模式',
  recommendedMode: '推荐模式',
  templateDescription: '模板描述',
  starterPrompt: '启动提示词',
  systemHint: '系统提示',
  suggestedTags: '建议标签',
  toolHints: '工具提示',
  templateActive: '模板启用',
  templateReadonlyHint: '你可以浏览模板并直接发起会话。',
  builtinTemplateCannotDelete: '内置模板不可删除，可改为停用',
  toolGovernance: '工具治理',
  mcpManagement: 'MCP 管理',
  templateManagement: '对话模板',
  governanceAdminOnly: '工具治理仅对管理员开放',
  approvalRequired: '需要审批',
  autoAllowed: '自动放行',
  toolDeferred: '延迟加载',
  toolDeferredOn: '按需检索启用',
  toolDeferredOff: '常驻绑定',
  riskTier: '风险等级',
  riskLow: '低风险',
  policySourceBuiltin: '内置',
  policySourceMcp: 'MCP',
  riskMedium: '中风险',
  riskHigh: '高风险',
  enabled: '已启用',
  disabled: '已禁用',
  allowedExperts: '允许专家',
  blockedExperts: '禁止专家',
  policyNote: '策略备注',
  policySaved: '工具策略已更新',
  savePolicy: '保存策略',
  noToolPolicySelected: '请选择一个工具策略进行编辑',
  saved: '已保存',

  // MCP
  add: '添加',
  deleted: '已删除',
  optional: '可选',
  serverNamePlaceholder: '例如：高德地图',
  serverNotConnected: '服务器未连接',
  serverDisabled: '服务器已禁用',
  failedToLoadTools: '加载工具列表失败',
  noMCPServers: '暂无 MCP 服务器',
  noMatchingServers: '未找到匹配的服务器',
  clickAddToConnect: '点击 ADD 添加 MCP 服务器',
  mcpTools: 'MCP 工具',
  addModule: '添加 MCP 服务器',
  mcpDescriptionPlaceholder: '描述此 MCP 服务器提供的功能（如：地图导航、天气查询）...',
  transport: '传输协议',
  transportProtocol: '协议',
  transportSSE: 'SSE (Server-Sent Events)',
  transportStreamableHTTP: 'Streamable HTTP',
  confirmDeleteMCPServer: '确定删除此 MCP 服务器？',
  removed: '已删除',
  toggleFailed: '切换失败',
  disable: '禁用',
  enable: '启用',
  moduleName: '模块名称',
  connecting: '连接中...',
  mcpServerAdded: 'MCP 服务器添加成功',
  editModule: '编辑 MCP 服务器',
  mcpServerUpdated: 'MCP 服务器已保存（工具清单即时生效）',
  failedToAddServer: '添加服务器失败',
  validationError: '验证错误',
  nameAndUrlRequired: '名称和 URL 为必填项',
  matching: '个匹配',

  // 模板导入导出
  importTemplate: '导入模板',
  exportTemplate: '导出模板',
  invalidFileType: '文件类型无效',
  pleaseSelectJsonFile: '请选择 JSON 文件',
  invalidTemplate: '模板无效',
  unknownError: '未知错误',
  fileReadError: '文件读取错误',
  importFailed: '导入失败',
  dragAndDropJson: '拖拽 JSON 文件到此处',
  or: '或',
  browseFiles: '浏览文件',
  templateValid: '模板有效，可以导入',
  templateInfo: '模板信息',
  key: '键',
  name: '名称',
  mode: '模式',
  importing: '导入中...',
  import: '导入',
  templateExists: '模板已存在',
  templateKeyConflict: '键为 "{key}" 的模板已存在',
  confirmDeleteTemplate: '删除模板',
  existingTemplate: '现有模板',
  builtinTemplate: '内置模板',
  customTemplate: '自定义模板',
  importStrategy: '导入策略',
  clone: '克隆',
  cloneDescription: '以不同的键导入为新模板',
  override: '覆盖',
  overrideDescription: '用此模板替换现有模板',
  skip: '跳过',
  skipDescription: '不导入此模板',
  importSuccess: '导入成功',
  importSkipped: '导入已跳过',
  close: '关闭',
  noToolPoliciesFound: '暂无工具策略',
  shareTemplate: '分享链接',
  templateShareCopied: '分享链接已复制',
  templateShareHint: '对方打开链接即可获取模板 JSON，在本系统「资源工坊 → 导入」粘贴即可完成导入。',
  templateShareFailed: '分享失败',
  exported: '已导出',
  templateExported: '模板导出成功',
  exportFailed: '导出失败',
  expectedArtifactTypes: '预期产出类型',
  artifactSchemaHint: '产出结构提示',
}

export const en = {
  // Knowledge Base
  searchKnowledge: 'Search knowledge base...',
  searchTemplates: 'Search templates...',
  searchTools: 'Search tool policies...',
  searchMCPServers: 'Search MCP servers...',
  documents: 'Documents',
  comingSoon: 'Coming Soon',
  knowledgeBaseDescription: 'Knowledge base feature is under development',
  skillTemplates: 'Chat Templates',
  // Artifact center
  artifactShareAction: 'Share',
  artifactShareCopied: 'Link copied',
  openSourceThread: 'Source chat',
  expertsLockedDesc: 'Capability pack management is available to the admin team only. Contact your administrator for access',
  expertsEditLockedDesc: 'Only super admins and edit admins can edit expert configurations',
  newTemplate: 'New Template',
  templateRequiredFields: 'Template key, name, and starter prompt are required.',
  templateSaved: 'Template saved successfully.',
  templateDeleted: 'Template deleted successfully.',
  templateNoDescription: 'No description',
  noTemplatesFound: 'No templates found',
  templateDetail: 'Template Detail',
  createTemplate: 'Create Template',
  templateEditorHint: 'Turn repeatable workflows into reusable entry points.',
  useTemplate: 'Use Template',
  templateKey: 'Template Key',
  category: 'Category',
  templateModeSimple: 'Simple Mode',
  templateModeComplex: 'Complex Mode',
  recommendedMode: 'Recommended Mode',
  templateDescription: 'Description',
  starterPrompt: 'Starter Prompt',
  systemHint: 'System Hint',
  suggestedTags: 'Suggested Tags',
  toolHints: 'Tool Hints',
  templateActive: 'Template Active',
  templateReadonlyHint: 'Browse templates and launch flows directly.',
  builtinTemplateCannotDelete: 'Builtin templates cannot be deleted. Disable them instead.',
  toolGovernance: 'Tool Governance',
  mcpManagement: 'MCP Management',
  templateManagement: 'Chat Templates',
  governanceAdminOnly: 'Tool governance is available to admins only.',
  approvalRequired: 'Approval Required',
  autoAllowed: 'Auto Allowed',
  toolDeferred: 'Deferred Loading',
  toolDeferredOn: 'On-demand via search',
  toolDeferredOff: 'Always bound',
  riskTier: 'Risk Tier',
  riskLow: 'Low Risk',
  policySourceBuiltin: 'Built-in',
  policySourceMcp: 'MCP',
  riskMedium: 'Medium Risk',
  riskHigh: 'High Risk',
  enabled: 'Enabled',
  disabled: 'Disabled',
  allowedExperts: 'Allowed Experts',
  blockedExperts: 'Blocked Experts',
  policyNote: 'Policy Note',
  policySaved: 'Tool policy updated successfully.',
  savePolicy: 'Save Policy',
  noToolPolicySelected: 'Select a tool policy to edit.',
  saved: 'Saved',

  // MCP
  add: 'Add',
  deleted: 'Deleted',
  optional: 'Optional',
  serverNamePlaceholder: 'e.g. Amap',
  serverNotConnected: 'Server not connected',
  serverDisabled: 'Server is disabled',
  failedToLoadTools: 'Failed to load tools',
  noMCPServers: 'No MCP servers',
  noMatchingServers: 'No matching servers',
  clickAddToConnect: 'Click ADD to connect an MCP server',
  mcpTools: 'MCP Tools',
  addModule: 'Add MCP Server',
  mcpDescriptionPlaceholder: 'Describe what this MCP server provides (e.g., map navigation, weather query)...',
  transport: 'Transport',
  transportProtocol: 'Protocol',
  transportSSE: 'SSE (Server-Sent Events)',
  transportStreamableHTTP: 'Streamable HTTP',
  confirmDeleteMCPServer: 'Remove this MCP server?',
  removed: 'removed',
  toggleFailed: 'Toggle failed',
  disable: 'Disable',
  enable: 'Enable',
  moduleName: 'Module Name',
  connecting: 'Connecting...',
  mcpServerAdded: 'MCP server added successfully',
  editModule: 'Edit MCP Server',
  mcpServerUpdated: 'MCP server saved (tool list effective immediately)',
  failedToAddServer: 'Failed to add server',
  validationError: 'Validation Error',
  nameAndUrlRequired: 'Name and URL are required',
  matching: 'matching',

  // Template Import/Export
  importTemplate: 'Import Template',
  exportTemplate: 'Export Template',
  invalidFileType: 'Invalid file type',
  pleaseSelectJsonFile: 'Please select a JSON file',
  invalidTemplate: 'Invalid template',
  unknownError: 'Unknown error',
  fileReadError: 'File read error',
  importFailed: 'Import failed',
  dragAndDropJson: 'Drag and drop your JSON file here',
  or: 'or',
  browseFiles: 'Browse files',
  templateValid: 'Template is valid and ready to import',
  templateInfo: 'Template Info',
  key: 'Key',
  name: 'Name',
  mode: 'Mode',
  importing: 'Importing...',
  import: 'Import',
  templateExists: 'Template already exists',
  templateKeyConflict: 'A template with key "{key}" already exists.',
  confirmDeleteTemplate: 'Delete Template',
  existingTemplate: 'Existing Template',
  builtinTemplate: 'Built-in template',
  customTemplate: 'Custom template',
  importStrategy: 'Import Strategy',
  clone: 'Clone',
  cloneDescription: 'Import as a new template with a different key',
  override: 'Override',
  overrideDescription: 'Replace the existing template with this one',
  skip: 'Skip',
  skipDescription: 'Do not import this template',
  importSuccess: 'Import Successful',
  importSkipped: 'Import Skipped',
  close: 'Close',
  noToolPoliciesFound: 'No tool policies found',
  shareTemplate: 'Share link',
  templateShareCopied: 'Share link copied',
  templateShareHint: 'Anyone with the link can fetch this template JSON and import it via Library → Import.',
  templateShareFailed: 'Share failed',
  exported: 'Exported',
  templateExported: 'Template exported successfully',
  exportFailed: 'Export failed',
  expectedArtifactTypes: 'Expected Artifact Types',
  artifactSchemaHint: 'Artifact Schema Hint',
}

export const ja = {
  // Knowledge Base
  searchKnowledge: 'ナレッジベースを検索...',
  searchTemplates: 'テンプレートを検索...',
  searchTools: 'ツールポリシーを検索...',
  searchMCPServers: 'MCPサーバーを検索...',
  documents: 'ドキュメント',
  comingSoon: '近日公開',
  knowledgeBaseDescription: 'ナレッジベース機能は開発中です',
  skillTemplates: 'チャットテンプレート',
  // 産物センター
  artifactShareAction: '共有リンク',
  artifactShareCopied: 'リンクをコピーしました',
  openSourceThread: '元の会話',
  expertsLockedDesc: '能力パック管理は管理チームのみ利用できます。操作が必要な場合は管理者にお問い合わせください',
  expertsEditLockedDesc: 'エキスパート設定を編集できるのはスーパー管理者と編集管理者のみです',
  newTemplate: '新規テンプレート',
  templateRequiredFields: 'テンプレートキー、名称、開始プロンプトは必須です',
  templateSaved: 'テンプレートを保存しました',
  templateDeleted: 'テンプレートを削除しました',
  templateNoDescription: '説明はありません',
  noTemplatesFound: 'テンプレートが見つかりません',
  templateDetail: 'テンプレート詳細',
  createTemplate: 'テンプレート作成',
  templateEditorHint: '繰り返し使うワークフローを再利用可能な入口にします。',
  useTemplate: 'テンプレートを使う',
  templateKey: 'テンプレートキー',
  category: 'カテゴリ',
  templateModeSimple: 'シンプルモード',
  templateModeComplex: '複雑モード',
  recommendedMode: '推奨モード',
  templateDescription: '説明',
  starterPrompt: '開始プロンプト',
  systemHint: 'システムヒント',
  suggestedTags: '推奨タグ',
  toolHints: 'ツールヒント',
  templateActive: 'テンプレート有効',
  templateReadonlyHint: 'テンプレートを参照してそのまま会話を開始できます。',
  builtinTemplateCannotDelete: '内蔵テンプレートは削除できません。代わりに無効化してください。',
  toolGovernance: 'ツールガバナンス',
  mcpManagement: 'MCP 管理',
  templateManagement: 'チャットテンプレート',
  governanceAdminOnly: 'ツールガバナンスは管理者のみ利用できます',
  approvalRequired: '承認が必要',
  autoAllowed: '自動許可',
  toolDeferred: '遅延ロード',
  toolDeferredOn: '検索で有効化',
  toolDeferredOff: '常時バインド',
  riskTier: 'リスク階層',
  riskLow: '低リスク',
  policySourceBuiltin: '内蔵',
  policySourceMcp: 'MCP',
  riskMedium: '中リスク',
  riskHigh: '高リスク',
  enabled: '有効',
  disabled: '無効',
  allowedExperts: '許可された専門家',
  blockedExperts: '禁止された専門家',
  policyNote: 'ポリシーメモ',
  policySaved: 'ツールポリシーを更新しました',
  savePolicy: 'ポリシーを保存',
  noToolPolicySelected: '編集するツールポリシーを選択してください',
  saved: '保存しました',

  // MCP
  add: '追加',
  deleted: '削除しました',
  optional: 'オプション',
  serverNamePlaceholder: '例：高德地図',
  serverNotConnected: 'サーバーが接続されていません',
  serverDisabled: 'サーバーが無効です',
  failedToLoadTools: 'ツール一覧の読み込みに失敗しました',
  noMCPServers: 'MCPサーバーがありません',
  noMatchingServers: '一致するサーバーがありません',
  clickAddToConnect: 'ADDをクリックしてMCPサーバーを追加',
  mcpTools: 'MCPツール',
  addModule: 'MCP サーバーを追加',
  mcpDescriptionPlaceholder: 'このMCPサーバーが提供する機能を説明（例：地図ナビ、天気予報）...',
  transport: 'トランスポート',
  transportProtocol: 'プロトコル',
  transportSSE: 'SSE (Server-Sent Events)',
  transportStreamableHTTP: 'Streamable HTTP',
  confirmDeleteMCPServer: 'このMCPサーバーを削除しますか？',
  removed: '削除しました',
  toggleFailed: '切り替えに失敗しました',
  disable: '無効化',
  enable: '有効化',
  moduleName: 'モジュール名',
  connecting: '接続中...',
  mcpServerAdded: 'MCPサーバーを追加しました',
  editModule: 'MCP サーバーを編集',
  mcpServerUpdated: 'MCPサーバーを保存しました（ツール一覧は即時反映）',
  failedToAddServer: 'サーバーの追加に失敗しました',
  validationError: '検証エラー',
  nameAndUrlRequired: '名前とURLは必須です',
  matching: '件一致',

  // テンプレートのインポート/エクスポート
  importTemplate: 'テンプレートをインポート',
  exportTemplate: 'テンプレートをエクスポート',
  invalidFileType: 'ファイルタイプが無効です',
  pleaseSelectJsonFile: 'JSONファイルを選択してください',
  invalidTemplate: 'テンプレートが無効です',
  unknownError: '不明なエラー',
  fileReadError: 'ファイル読み取りエラー',
  importFailed: 'インポートに失敗しました',
  dragAndDropJson: 'JSONファイルをここにドラッグ＆ドロップ',
  or: 'または',
  browseFiles: 'ファイルを参照',
  templateValid: 'テンプレートは有効で、インポートできます',
  templateInfo: 'テンプレート情報',
  key: 'キー',
  name: '名称',
  mode: 'モード',
  importing: 'インポート中...',
  import: 'インポート',
  templateExists: 'テンプレートが既に存在します',
  templateKeyConflict: '"{key}" というキーのテンプレートが既に存在します',
  confirmDeleteTemplate: 'テンプレートを削除',
  existingTemplate: '既存のテンプレート',
  builtinTemplate: '内蔵テンプレート',
  customTemplate: 'カスタムテンプレート',
  importStrategy: 'インポート戦略',
  clone: 'クローン',
  cloneDescription: '異なるキーで新しいテンプレートとしてインポート',
  override: '上書き',
  overrideDescription: '既存のテンプレートをこのテンプレートで置き換え',
  skip: 'スキップ',
  skipDescription: 'このテンプレートをインポートしない',
  importSuccess: 'インポート成功',
  importSkipped: 'インポートをスキップしました',
  close: '閉じる',
  noToolPoliciesFound: 'ツールポリシーがありません',
  shareTemplate: '共有リンク',
  templateShareCopied: '共有リンクをコピーしました',
  templateShareHint: 'リンクを開くとテンプレート JSON を取得できます。本システムの「ライブラリ → インポート」に貼り付けてください。',
  templateShareFailed: '共有に失敗しました',
  exported: 'エクスポートしました',
  templateExported: 'テンプレートをエクスポートしました',
  exportFailed: 'エクスポートに失敗しました',
  expectedArtifactTypes: '予想されるアーティファクトタイプ',
  artifactSchemaHint: 'アーティファクト構造のヒント',
}
